














import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ImageObjectTypes } from "@/models/images";

// Types
import { IState } from "@/store";
import { IProductCategory } from "@/models/products";

@Component({
  computed: {
    ...mapState({
      imagesScope(state: IState, getters) {
        return getters[`data/${DataModules.IMAGES}/imagesScope`](
          this.categoryId,
          this.imageType
        );
      },
      images(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.IMAGES,
          scope: this.imagesScope
        });
      }
    })
  }
})
export default class CategoryImageCarousel extends Mixins(RequestPromises) {
  // Getters
  public imagesScope!: string;
  public images!: any;

  // Props
  @Prop({ required: true })
  public categoryId!: IProductCategory["id"];

  @Prop({ default: 8 })
  public limit!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Variables
  public imageType: string = ImageObjectTypes.PRODUCT_CATEGORY;

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  // Life-cycle methods

  public created() {
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.IMAGES,
      scope: this.imagesScope,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await this.getCategoryImages(this.isReloading);
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getCategoryImages(ignoreStored = false) {
    return this.$store.dispatch(`data/${DataModules.IMAGES}/list`, {
      typeId: this.categoryId,
      imageType: this.imageType,
      scope: this.imagesScope,
      vm: this,
      ignoreStored,
      params: {
        limit: this.limit,
        order: "order"
      }
    });
  }
}
